export default __webpack_public_path__ + "static/media/levelup.4f5ec3f8.png";